import { recordThrowEvent } from './throwCombo';

export const PHASE_ANCHOR_DURATION_MS = 4000;
export const PHASE_ANCHOR_TIME_SCALE = 0.2;

export const getPhaseAnchorState = (game) => {
  const owned = !!game.relics?.includes('phaseAnchor');
  const used =
    Number.isInteger(game.phaseAnchor?.usedFloor) &&
    game.phaseAnchor.usedFloor === game.floor;
  return {
    owned,
    used,
    available: owned && !used,
    // Kept for older saves and callers; Phase Anchor no longer has an arm step.
    armed: false,
  };
};

export const activatePhaseAnchor = (game) => {
  if (
    !getPhaseAnchorState(game).available ||
    !['rolled', 'bossPlayerRolled'].includes(game.phase) ||
    Number.isInteger(game.landingIndex)
  )
    return game;
  return {
    ...recordThrowEvent(game, 'anchor'),
    phaseAnchor: { armed: false, usedFloor: game.floor },
  };
};
